/** Tracks where the shopper is and where they came from. Pure state; playback lives elsewhere. */
export class Navigator {
  private stack: string[] = [];
  private _current: string;

  constructor(start: string) {
    this._current = start;
  }

  get current(): string {
    return this._current;
  }

  get canGoBack(): boolean {
    return this.stack.length > 0;
  }

  get history(): readonly string[] {
    return this.stack;
  }

  /** Record arrival at `id`. Arriving where you already are is a no-op. */
  arrive(id: string): void {
    if (id === this._current) return;
    this.stack.push(this._current);
    this._current = id;
  }

  /** The location Back would return to, without moving. */
  peekBack(): string | undefined {
    return this.stack[this.stack.length - 1];
  }

  /** Step back in history; returns the new current location (or undefined when there is none). */
  back(): string | undefined {
    const prev = this.stack.pop();
    if (prev !== undefined) this._current = prev;
    return prev;
  }
}
